"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaterQualityColor = exports.WaterQualityThreshold = void 0;
// TDS (ppm) bands anchored to EPA / WHO drinking-water guidance.
// Sensor reports EC (µS/cm); converted to TDS via the standard 0.6 factor before banding.
var WaterQualityThreshold;
(function (WaterQualityThreshold) {
    WaterQualityThreshold[WaterQualityThreshold["excellent"] = 150] = "excellent";
    WaterQualityThreshold[WaterQualityThreshold["good"] = 300] = "good";
    WaterQualityThreshold[WaterQualityThreshold["acceptable"] = 600] = "acceptable";
    WaterQualityThreshold[WaterQualityThreshold["hard"] = 900] = "hard";
    WaterQualityThreshold[WaterQualityThreshold["concerning"] = 1200] = "concerning";
})(WaterQualityThreshold = exports.WaterQualityThreshold || (exports.WaterQualityThreshold = {}));
var WaterQualityColor;
(function (WaterQualityColor) {
    WaterQualityColor["Red"] = "red";
    WaterQualityColor["Yellow"] = "yellow";
    WaterQualityColor["Blue"] = "blue";
})(WaterQualityColor = exports.WaterQualityColor || (exports.WaterQualityColor = {}));
